module.exports = __webpack_public_path__ + "static/img/far4_active.c7331368.png";